// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** Otp Verify Mobile Number Start ************************/
export const addMemberMobileNumberVeriyOtp = (verifyData: any) => {
	const data = {
		AddMemberOtpToken: verifyData,
	};
	const url = `${API_URL}verifyAddMemberOtp`;
	return makeApiCall(url, data);
};
/** ***************** Otp Verify Mobile Number End ************************/

/** ***************** Resend Otp Verify Mobile Number Start ************************/
export const verifyResendOtp = (resendOtpData: any) => {
	const data = {
		VerifyReSendOtpToken: resendOtpData,
	};
	const url = `${API_URL}otpSend`;
	return makeApiCall(url, data);
};
/** ***************** Resend Otp Verify Mobile Number End ************************/
